
import { Component, Mixins } from 'vue-property-decorator';
import { ListingStatus } from 'client-website-ts-library/types';
import { AsyncView, RouteMeta } from 'client-website-ts-library/plugins';
import { ListingFilter } from 'client-website-ts-library/filters';

import Listings from '@/components/Listings.vue';
import Loader from '@/components/UI/Loader.vue';

@Component({
  components: {
    Listings,
    Loader,
  },
})
export default class Auctions extends Mixins(AsyncView) {
  private listingFilter: ListingFilter = new ListingFilter({
    Statuses: [
      ListingStatus.Current,
    ],
    PageSize: 9,
  });

  public head(): RouteMeta {
    return {
      title: 'Upcoming auctions with Quaid Auctioneers',
      description: 'Upcoming auctions with Quaid Auctioneers',
    };
  }
}
